import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-footer',
  templateUrl: './auth-footer.component.html',
  styleUrls: ['../authentication.component.css']
})
export class AuthFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
